import { render } from "./sitemap.vue?vue&type=template&id=f3fc5e7e"
import script from "./sitemap.vue?vue&type=script&lang=js"
export * from "./sitemap.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__